// import * as icons from "@material-ui/icons";
import { Button, Checkbox, Chip, FormControlLabel, FormGroup, Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { compose } from 'recompose';
import { Dispatch } from 'redux';

import Search from '../../components/Search/Search';
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../components/Table';
import TablePagination, { IPageEvent } from '../../components/TablePagination/TablePagination';
import withDialog, { IDialogProps } from '../../hoc/Dialog';
import { IPaginationMetaResponse, IPaginationParams } from '../../libs/quickjobs-api';
import {
  blockUserRequest,
  fetchUsersRequest,
  IUserBlockRequestAction,
  IUserRemoveRequestAction,
  IUsersFetchRequestAction,
  removeUserRequest,
} from '../../store/actions/users';
import { IUser, IUsersState } from '../../store/types/user';

import styles from './styles';

class Users extends React.Component<IProps & IDialogProps, IState> {
  private static readonly SWITCHER_EMPLOYERS = 'SHOW_EMPLOYERS';
  private static readonly SWITCHER_CANDIDATES = 'SHOW_CANDIDATES';
  private static readonly DEFAULT_LIMIT = 10;

  public state = {
    showEmployers: true,
    showCandidates: true,
    limit: Users.DEFAULT_LIMIT,
  };

  public componentDidMount() {
    this.props.fetchUsers(this.getRoles(), { limit: this.state.limit });
  }

  public componentDidUpdate(prevProps: any, prevState: any) {
    const previousRoles = this.getRoles(prevState);
    const newRoles = this.getRoles();

    if (previousRoles.length !== newRoles.length) {
      this.props.fetchUsers(this.getRoles(), { limit: this.state.limit });
    }
  }

  public handleRoleSwitcher(
    switcher: typeof Users.SWITCHER_EMPLOYERS | typeof Users.SWITCHER_CANDIDATES
  ) {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      if (switcher === Users.SWITCHER_EMPLOYERS) {
        this.setState({
          ...this.state,
          showEmployers: event.target.checked,
        });
      } else if (switcher === Users.SWITCHER_CANDIDATES) {
        this.setState({
          ...this.state,
          showCandidates: event.target.checked,
        });
      }
    };
  }

  public onSearch() {
    return (value: string) => {
      this.props.fetchUsers(this.getRoles(), { search: value, limit: this.state.limit });
    };
  }

  public blockUser(user: IUser) {
    return () => {
      this.props.openDialog(
        `${user.enabled ? 'Block' : 'Unblock'} the User ${user.id}`,
        'Are you sure you want to perform this action?',
        () => {
          this.props.blockUser(user.id, !user.enabled);
        }
      );
    };
  }

  public removeUser(id: number) {
    return () => {
      this.props.openDialog(
        `Remove the User ${id}`,
        'Are you sure you want to remove this user?',
        () => {
          this.props.removeUser(id);
        }
      );
    };
  }

  public handlePagination() {
    return (event: IPageEvent, limit: number) => {
      this.setState({ limit });
      switch (event) {
        case IPageEvent.FIRST_PAGE:
          this.props.fetchUsers(this.getRoles(), {
            limit: limit,
          });
          break;
        case IPageEvent.BACK:
          const firstJob: IUser = this.props.users[0];
          this.props.fetchUsers(this.getRoles(), {
            since: firstJob.created_at,
            limit: limit,
          });
          break;
        case IPageEvent.NEXT:
          const lastJob: IUser = this.props.users[this.props.users.length - 1];
          this.props.fetchUsers(this.getRoles(), {
            until: lastJob.created_at,
            limit: limit,
          });
          break;
      }
    };
  }

  public render() {
    const rows = this.props.users as IUser[];
    const meta = this.props.meta;
    const isSales = this.props.loggedInUser.roles.includes('sales');

    return (
      <>
        <Paper className={this.props.classes.root}>
          <FormGroup row={true}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.showEmployers}
                  onChange={this.handleRoleSwitcher(Users.SWITCHER_EMPLOYERS)}
                  value="showEmployers"
                />
              }
              label="Show Employers"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.showCandidates}
                  onChange={this.handleRoleSwitcher(Users.SWITCHER_CANDIDATES)}
                  value="showCandidates"
                  color="primary"
                />
              }
              label="Show Candidates"
            />
          </FormGroup>
          <Search onSubmit={this.onSearch()} />
          {rows.length ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell numeric={true}>ID</TableCell>
                  <TableCell>Roles</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone</TableCell>
                  <TableCell>Platform</TableCell>
                  <TableCell hidden={isSales}>Description</TableCell>
                  <TableCell hidden={isSales}>Avatar</TableCell>
                  <TableCell hidden={isSales}>Body</TableCell>
                  <TableCell hidden={isSales}>Face</TableCell>
                  <TableCell hidden={isSales}>Optional</TableCell>
                  <TableCell>Registered</TableCell>
                  <TableCell hidden={isSales}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(r => {
                  return (
                    <TableRow key={r.id} hover={true}>
                      <TableCell numeric={true}>{r.id}</TableCell>
                      <TableCell>
                        {r.roles.map(role => (
                          <Chip key={role} label={role} />
                        ))}
                      </TableCell>
                      <TableCell>
                        {r.given_name} {r.family_name}
                      </TableCell>
                      <TableCell>{r.email}</TableCell>
                      <TableCell>{r.phone}</TableCell>
                      <TableCell>{r.platform}</TableCell>
                      <TableCell hidden={isSales}>{r.description}</TableCell>
                      <TableCell hidden={isSales}>
                        <a href={get(r, 'avatar_image.url')} target="_blank">
                          <img src={get(r, 'avatar_image.url')} width="80" />
                        </a>
                      </TableCell>
                      <TableCell hidden={isSales}>
                        <a href={get(r, 'body_image.url')} target="_blank">
                          <img src={get(r, 'body_image.url')} width="80" />
                        </a>
                      </TableCell>
                      <TableCell hidden={isSales}>
                        <a href={get(r, 'face_image.url')} target="_blank">
                          <img src={get(r, 'face_image.url')} width="80" />
                        </a>
                      </TableCell>
                      <TableCell hidden={isSales}>
                        <a href={get(r, 'optional_image.url')} target="_blank">
                          <img src={get(r, 'optional_image.url')} width="80" />
                        </a>
                      </TableCell>
                      <TableCell>{new Date(r.created_at).toLocaleString('cs-CZ')}</TableCell>
                      <TableCell hidden={isSales}>
                        <Link to={`/users/${r.id}`}>
                          <Button variant="contained" color="primary">
                            Detail
                          </Button>
                        </Link>
                        <Button
                          variant="contained"
                          color="secondary"
                          disabled={!!r.deleted_at}
                          onClick={this.blockUser(r)}
                        >
                          {r.enabled ? 'Block' : 'Unblock'}
                        </Button>
                        {/*<Button
                          variant="contained"
                          disabled={!!r.deleted_at}
                          onClick={this.removeUser(r.id)}
                        >
                          {!!r.deleted_at ? 'Removed' : 'Remove'}
                        </Button>*/}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) : null}
          {meta ? (
            <TablePagination
              hasPreviousPage={meta.has_previous}
              hasNextPage={meta.has_next}
              onChangePage={this.handlePagination()}
              defaultLimit={this.state.limit}
            />
          ) : null}
        </Paper>
      </>
    );
  }

  private getRoles(customState?: any): Array<'employer' | 'candidate'> {
    const state = customState || this.state;
    const roles: Array<'employer' | 'candidate'> = [];
    if (state.showCandidates) {
      roles.push('candidate');
    }
    if (state.showEmployers) {
      roles.push('employer');
    }
    return roles;
  }
}

interface IProps {
  loggedInUser: IUser;
  users: IUser[];
  meta: IPaginationMetaResponse | undefined;
  fetchUsers: (
    roles: Array<'candidate' | 'employer'>,
    params?: { search?: string } & IPaginationParams
  ) => IUsersFetchRequestAction;
  removeUser: (id: number) => IUserRemoveRequestAction;
  blockUser: (id: number, block: boolean) => IUserBlockRequestAction;

  classes: { [name: string]: string };
}

interface IState {
  showEmployers: boolean;
  showCandidates: boolean;
  limit: number;
}

const mapStateToProps = (state: { users: IUsersState, auth: any }) => {
  return {
    loggedInUser: state.auth.user,
    users: state.users.users || [],
    meta: state.users.meta,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchUsers: (
      roles: Array<'candidate' | 'employer'>,
      params?: { search?: string } & IPaginationParams
    ) => dispatch(fetchUsersRequest(roles, params)),
    removeUser: (id: number) => dispatch(removeUserRequest(id)),
    blockUser: (id: number, block: boolean) => dispatch(blockUserRequest(id, block)),
  };
};
export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles),
  withDialog
)(Users);



// WEBPACK FOOTER //
// ./src/screens/Users/Users.tsx